import React, {Component} from 'react';
import './NavList.css';
import Input from './Input';
import Button from './Button';
import Loading from './Loading';

const getSearchValue = (props, state) => ((props.managedSearch ? props.searchValue : state.search) || '');

class NavList extends Component {
	constructor() {
		super();
		
		this.state = {
			collapsed: false,
			search: ''
		};
		
		this.toggleCollapse = () => this.setState({collapsed: !this.state.collapsed});

		this.onSearchChange = e => {
			if (!this.props.managedSearch) {
				this.setState({search: e.target.value});
			}
			this.props.onSearchChange(e);
		}

		this.clearSearch = () => this.onSearchChange({target: {value: ''}});
	}
	
	render() {
		const {
			className, disabled, children, searchPlaceholder = 'Search',
			theme = 'yellow', loading = false, onAdd, managedSearch = false, searchValue
		} = this.props;

		return (
			<nav className={`NavList ${disabled ? 'disabled' : ''} ${className || ''} ${this.state.collapsed ? 'collapsed' : ''}`} style={{borderRightColor: `var(--${theme})`}}>
				<Button
					onClick={this.toggleCollapse}
					className="NavList-collapse"
					theme={theme}>
					<img src="/keyboard_arrow_left.svg" />
				</Button>
				<header>
					<span className="NavList-search">
						<Input type="search" value={getSearchValue(this.props, this.state)} placeholder={searchPlaceholder} onChange={this.onSearchChange} disabled={disabled}/>
						<button className={getSearchValue(this.props, this.state).length > 0 ? '' : 'hidden'} onClick={this.clearSearch}>🞩</button>
					</span>
					<Button className="add" size="large" onClick={disabled ? undefined : onAdd} disabled={disabled}>+</Button>
				</header>
				<div className="NavList-items">
					{loading ? (<Loading />) : children}
				</div>
			</nav>
		);
	}
}
		
export default NavList;


// WEBPACK FOOTER //
// ./src/widgets/NavList.js